
<p-dialog header="{{'Sign History' | translator}}" (onHide)="hide()" [(visible)]="visible" [modal]="true" [style]="{ width: '95vw' , maxWidth: '1200px' }" [draggable]="false" [resizable]="false">
  
  <div *ngIf="signHistory?.history.length">
    <div *ngFor="let entry of signHistory.history.reverse()" class="sign-history-entry">
      <div class="d-flex align-items-center">
        <span class="icon-box">
      <i [ngClass]="entry.status ? 'pi pi-check-circle mx-3 color-green' : 'pi pi-exclamation-circle mx-3 color-yellow'"></i>
    </span>
      <span class="v4-font-600">{{ entry.user_name }}</span>
    </div>
    <div>
      <span>{{ entry.date | date:'short' }}</span>
    </div>
    </div>
  </div>
  <app-no-data *ngIf="!signHistory?.history.length"></app-no-data>

</p-dialog>